import ImageLayer from 'ol/layer/Image.js';
import Static from 'ol/source/ImageStatic.js';


export default class Grid {

	constructor(projection,imageSize,extent) {
    	 this.name = 'Grid';
    	 var gridSource = new ImageLayer({
                        title: this.name,
                        displayInLayerSwitcher: true,
                        class : 'grid',
  	                    source: new Static({
  	                        url: './public/svg/Grid-map.svg',
  	                        imageSize: /*imageSize,*/ [2800, 1280],
  	                        projection: projection,
  	                        imageExtent: extent,
  	                    })
  	                });
    	 this.gridSource = gridSource ;

  	}

  	toString() {
        return this.name;
    }


    getGridLayer() {
    	return this.gridSource;
    }


}